module.exports = __webpack_public_path__ + "static/media/Planet4.1_Moon.b2da4fe5.svg";